export default __webpack_public_path__ + "static/media/icon_lock.589300c0.svg";